export default __webpack_public_path__ + "static/media/P10015.ee956bfb.png";